import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { BaseService } from 'src/app/services/common/base.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-refund-to-farmer-aby',
  templateUrl: './refund-to-farmer-aby.component.html',
  styleUrls: ['./refund-to-farmer-aby.component.scss'],
  providers: [DatePipe],
})
export class RefundToFarmerAbyComponent implements OnInit {

  @ViewChild('refundToFarmerPFMSReportTable', { static: true }) public refundToFarmerPFMSReportTable: any;

  selectedBankAccounts: any[];

  submitted: boolean;
  menuItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  refundToFarmerPFMSReportModel: any[];
  addDialog: boolean;

  lotNo: number;
  public filteredData: any = [];
  selectedStatus: any;
  remarks: String;
  date: any;
  public userID: any;
  miSurveyData: any[];
  items: any[];
  appVerificationItems: MenuItem[];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  filteredDataForExport: any = [];
  ipAddress: any = '000.000.000';
  public loading: boolean = false;
  public loading1: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;


  constructor(
    private messageService: MessageService, 
    private caoService: CaoService, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService, 
    private dashboard: DashboardService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private datePipe: DatePipe,
    ) { }

  ngOnInit() {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.getIP();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.refundToFarmerPFMSReportModel, "MI Subsidy To Farmer PFMS Report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.refundToFarmerPFMSReportModel, "MI Subsidy To Farmer PFMS Report");
        }
      },
    ];

    // let actionId = 28; // Do not Change, it is fixed for Farmer Application Verifications
    // this.deptDashBoardService
    //   .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       this.items = data.$values;
    //     },
    //     error: () => {
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: 'Status Master cant be Loaded',
    //       });
    //     },
    //   });

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.miSurveyData, `${this.lotNo}_(${this.date})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
      //   }
      // },
    ];

  }
  
  
  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.loadData();
   
        this.selectedYear = res;
        this.refundToFarmerPFMSReportTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  selectFarmerApplication(application) {
    if(application.Scheme_Specific_Id){
      // this.loader.start();
    this.loading = true;
    let sub=this.dashboard
      .getMIDetailByAppID(application.Scheme_Specific_Id)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loading = false;
          const link = this.router.serializeUrl(
            this.router.createUrlTree([
              this.router.url.split('/')[1],
              'print',
            ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
          // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
          window.open(link, '_blank');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
      this.subscriptions.push(sub);
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  loadData() {
    // this.loader.start();
    this.loading = true;
    let sub=this.caoService.miRefundToFarmerPFMSReport("isAtal")
      .pipe(first())
      .subscribe({
        next: (data) => {
           // this.loader.close();
           this.loading = false;
          data = data.map(val => ({ 
            ...val,
            lotNoForSorting: parseInt(val?.Lot_No.slice(7))
          }))
          this.activityRecordService.activityRecord(this.userID, 'Return To Farmer PFMS Report (ABY)', '', new Date(), 'Success');

          if (data.length > 0) {
            // console.log(data,"data")
            this.refundToFarmerPFMSReportModel = data;
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Return To Farmer PFMS Report (ABY)', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error!  not loaded.' });

        }
      });
      this.subscriptions.push(sub);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Srno', header: 'Sr no' },
      { field: 'Lot_No', header: 'File No' },
      { field: 'dateofExport', header: 'Date of Export' },
      { field: 'No_of_AllRecords', header: 'No of Record' },
      { field: 'Sum_of_PFMS_Export', header: 'Sum of PFMS Export' },
      { field: 'Sum_of_Successfull_Records', header: 'Sum of Successfull Records' },
      { field: 'Sum_of_Failed_Records', header: 'Sum of Failed Records' },
      { field: 'Sum_of_Bank_Transfer_Successfull_Records', header: 'Sum of Bank Transfer Successfull Records' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }


  hideDialog() {
    this.addDialog = false;
    this.miSurveyData = [];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Sr no": d.Srno,
          "File No": d.Lot_No,
          "Date of Export": d.dateofExport,
          "No of Record": d.No_of_AllRecords,
          "Sum of PFMS Export": d.Sum_of_PFMS_Export,
          "Sum of Successfull Records": d.Sum_of_Successfull_Records,
          "Sum of Failed Records": d.Sum_of_Failed_Records,
          "Sum of Bank Transfer Successfull Records": d.Sum_of_Bank_Transfer_Successfull_Records,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // handleClick() {
  //   let newFilteredData = this.filteredData.map(row => ({
  //     ...row,
  //     status: this.selectedStatus.flag,
  //     remarks: this.remarks ? this.remarks : 'undefined',
  //   }))

  //   let reqBody = {
  //     listLotData: newFilteredData,
  //     userID: this.userID,
  //     network_Id: this.ipAddress,
  //     terminal_Id: this.ipAddress,
  //     subSidyType: 'FTV',
  //   }
  //   console.log("reqBody", reqBody)

  //   this.insertMISubsidyLot(reqBody);
  // }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    // this.loader.start();
    this.loading = true;
    this.deptDashBoardService.insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
          this.pmfsExport(reqBody.Lot_No, '');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  refreshTable(){
    this.loadData();
  }

  pmfsExport(lotId, status) {
    this.addDialog = true;
    this.lotNo = lotId;
    // this.loader.start();
    this.loading1 = true;
    this.caoService.miRefundToFarmerPFMSExport(lotId, status, 'isAtal')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          // console.log("dataaa", data)
          if (data?.length > 0) {
            this.miSurveyData = data;
            this.miSurveyData = this.miSurveyData.map(row => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat("_", row.ProgramID)
            }))
            // console.log("RTFdata", this.miSurveyData);
          }
          else{
            this.miSurveyData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
          this.activityRecordService.activityRecord(this.userID, 'Return To Farmer PFMS Export (ABY)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.miSurveyData = [];
          // this.loader.close();
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Return To Farmer PFMS Export (ABY)', lotId, new Date(), err);
        }
      });
  }

  // onRowSelect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Selected',
  //     detail: event.data.name,
  //   });
  // }

  // onRowUnselect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Unselected',
  //     detail: event.data.name,
  //   });
  // }

  // calculation() {
  //   this.filteredData = [];
  //   // this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;

  //   this.totalSelectedApp = this.filteredDataForExport.length;
  //   this.filteredDataForExport.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   this.filteredDataForExport.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.Scheme_Specific_Id,
  //         programID: val.ProgramID,
  //         subsidy_Amt: 0,
  //         amt_Disbus_to_Vendor: 0,
  //         amt_Refund_to_Farmer: 0,
  //         refundToFarmer: val.Farmer_Share_To_Vendor,
  //         state_share_amt: val.State_Share_Payment_Amount,
  //         centre_share_amt: val.Center_Share_Payment_Amount,
  //       })
  //   })
  // }

  pfmsExportExcel(modelData, filename) {
    this.countNoOfTimesExported();
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Full Name in English': d.Farmer_Name_In_English,
          'Full Name in Recognized Official Language': d.Full_Name_in_Recognized_Official_Language,
          'Gender': d.Gender,
          'Address Line 1': d.Address_Line_1,
          'Address Line 2': d.Address_Line_2,
          'Address Line 3': d.Address_Line_3,
          'Village': d.Village,
          'Block': d.Block,
          'District': d.District,
          'State': d.State,
          'Country': d.Country,
          'Farmer Type': d.FarmerType,
          'Farmer Bank Name': d.Farmer_Bank_Name,
          'Farmer IFSCCode': d.Farmer_IFSCCode,
          'Farmer Account Number': d.Farmer_Account_Number ? d.Farmer_Account_Number.toString() : '',
          'Aadhaar Number': d.Aadhar_Number ? d.Aadhar_Number.toString() : '',
          'Pincode': d.Pincode,
          'Scheme Specific ID': d.Scheme_Specific_Id,
          'Challan No': d.ChallanNo,
          'UTR': d?.UTR,
          'Credited Date': this.datePipe.transform(new Date(d?.CreditedOnDateTime), 'dd-MM-yyyy'),
          'Refund To Farmer': d.Refund_To_Farmer,
          'Programme Name': d?.Programme_Name,
          'Crop Name': d?.Crop_Name,
          'User Type': d?.UserType,
          'Application Type': d?.ApplicantType,
          'MI Area': d?.MIArea,
          'Total Area': d?.Total_Area,
          'Remarks': d?.Remarks,
          'CAO Remarks': d?.CAORemarks,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  countNoOfTimesExported(){
    let reqBody = {
      LotType: 'RTF',
      SubTypeLot: 'ABY',
      LotNo: this.lotNo,
      UserId: this.userID,
      Network_Id: this.ipAddress,
      Terminal_Id: this.ipAddress 
    }

    this.postCountExportDataFrequency(reqBody);
  }

  postCountExportDataFrequency(reqBody) {
    // this.loader.start();
    this.loading = true;
    this.deptDashBoardService
      .postCountExportDataFrequency(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: data.Result,
          });
          this.loadData();
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -3) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1 || row.PendingCompletedDays == -2) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }
}

